import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RootState } from 'app/store';

import { AddOn } from 'apis/nswag';

interface CustomReportState {
  employerIds: number[];
  carrierIds: number[];
  divisionIds: number[];
  addOns: AddOn[];
}

const initialState: CustomReportState = {
  employerIds: [],
  carrierIds: [],
  divisionIds: [],
  addOns: [],
};

const customReportSlice = createSlice({
  name: 'customReport',
  initialState,
  reducers: {
    setEmployerIds: (state, action: PayloadAction<number[]>) => {
      state.employerIds = action.payload;
    },
    setCarrierIds: (state, action: PayloadAction<number[]>) => {
      state.carrierIds = action.payload;
    },
    setDivisionIds: (state, action: PayloadAction<number[]>) => {
      state.divisionIds = action.payload;
    },
    setAddOns: (state, action: PayloadAction<AddOn[]>) => {
      state.addOns = action.payload;
    },
    resetCustomReportState: (state) => {
      state.employerIds = [];
      state.carrierIds = [];
      state.divisionIds = [];
      state.addOns = [];
    },
  },
});

export const { setEmployerIds, setCarrierIds, setDivisionIds, setAddOns, resetCustomReportState } =
  customReportSlice.actions;

export const customReportSelector = (state: RootState) => state.customReport;

export default customReportSlice.reducer;
